// Role helpers for client-dashboard access. The dashboard was client-only;
// Social Media Specialists (SMS) may now open it to present a client's report
// (read-only) but are kept out of financial/account surfaces.

export const SMS_ROLE = 'Social Media Specialist'

export const getRoleName = (user) => user?.role?.name || null

export const isSMS = (user) => getRoleName(user) === SMS_ROLE

// Surfaces an SMS may NOT reach (Invoice + Profile).
export const SMS_HIDDEN_PATHS = ['/invoice', '/profile']

export const isPathHiddenForUser = (user, href) =>
  isSMS(user) && SMS_HIDDEN_PATHS.includes(href)

// Drop menu entries the current user may not access (keeps nav labels).
export const filterMenuForUser = (items, user) =>
  items.filter((item) => !isPathHiddenForUser(user, item.href))
